import React from 'react';
import { IconButton, makeStyles, Tooltip, ClickAwayListener } from '@material-ui/core'
import { Help } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  buttonArea: {
    verticalAlign: 'sub',
    display: 'inline-block',
    textAlign: 'center',
    margin: 0,
    height: 0,
    position: 'relative',
    top: '-.7rem',
  },
  callout: {
    maxWidth: 'min(500px, 90vw)',
    fontSize: '1rem',
  },
  inner: {
    height: '100%',
    padding: 10,
  },
  button: {
    height: 0,
    marginBottom: 7,
    width: 25
  }
}));

const CustomTooltip = ({ text, disabled }: { text: string, disabled?: boolean }) => {
  const styles = useStyles();
  const [isCalloutVisible, setCalloutVisible] = React.useState(false);

  return (
    <ClickAwayListener onClickAway={() => setCalloutVisible(false)}>
      <div className={styles.buttonArea}>
        <Tooltip
          disableHoverListener
          classes={{ tooltip: styles.callout }}
          className={styles.callout}
          open={isCalloutVisible}
          onClose={() => setCalloutVisible(false)}
          title={<span dangerouslySetInnerHTML={{ __html: text }} />}
        >
          <IconButton
            disabled={disabled}
            id="callout-label"
            className={styles.button}
            onClick={() => setCalloutVisible(!isCalloutVisible)}
          >
            <Help />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default CustomTooltip;
